<template>
  <v-container fluid>
    <v-layout justify-center align-top row wrap>
      <v-flex xs12 sm10 md8 lg7 text-xs-center>
        По всем вопросам обращайтесь
      </v-flex>
      <v-flex xs12>&nbsp;</v-flex>
      <v-flex xs12 text-xs-center>Email: <a href="mailto:kastrulin@gmail.com">kastrulin@gmail.com</a></v-flex>
      <v-flex xs12 text-xs-center>Telegram: <a href="https://telegram.im/@evriday_app" target="_blank">@evriday_app</a></v-flex>
      <v-flex xs12 text-xs-center>Телефон: +375 29 298 84 72</v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  created () {
    this.$store.commit('showNavigation')
  }
}
</script>
